export class Content {
  constructor(public key: string, public value: any, public id?: number, public pageContents?: Array<PageContent>) {}
}

export interface PageContent {
  page_id?: number;
  sortOrder?: number;
}
